export const syllabusRoutesData = [
  {
    name: "CSE",
    to: "/syllabus/cse",
    expansion: "Computer Science and Engineering",
  },
  {
    name: "IT",
    to: "/syllabus/it",
    expansion: "Information Technology",
  },
  {
    name: "ECE",
    to: "/syllabus/ece",
    expansion: "Electronics and Communication Engineering",
  },
  {
    name: "EEE",
    to: "/syllabus/eee",
    expansion: "Electrical and Electronics Engineering",
  },
  {
    name: "MECH",
    to: "/syllabus/mech",
    expansion: "Mechanical Engineering",
  },
  {
    name: "BME",
    to: "/syllabus/auto",
    expansion: "Bio Medical Engineering",
  },
  {
    name: "CIVIL",
    to: "/syllabus/civil",
    expansion: "Civil Engineering",
  },
  {
    name: "FT",
    to: "/syllabus/ft",
    expansion: "Fashion Technology",
  },
  {
    name: "MCT",
    to: "/syllabus/mct",
    expansion: "Mechatronics Engineering",
  },
  {
    name: "ADS",
    to: "/syllabus/ads",
    expansion: "Artificial Intelligence and Data Science",
  },
  {
    name: "AIML",
    to: "/syllabus/aiml",
    expansion: "Artificial Intelligence and Machine Learning",
  },
  {
    name: "CSD",
    to: "/syllabus/csd",
    expansion: "Computer Science and Design",
  },
];
